import { useAppSelector } from 'redux/hooks';
import { Pager } from '@doda/io-react/pc';
import {
  appQueryParamsSelector,
  condQuerySelector,
} from '@doda/common/src/redux/features/queryParams';
import type { AppQueryParams } from '@doda/common/src/constants/queryParams';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import { totalJobCountSelector } from 'redux/features/jobList';
import { JOB_COUNT_PER_PAGE } from 'constants/jobList';

/**
 * Paginationコンポーネント
 *
 * @returns {JSX.Element} ページネーションコンポーネントのJSX要素
 */
export const Pagination = () => {
  const { page = '1' } = useAppSelector(appQueryParamsSelector);
  const totalCount = useAppSelector(totalJobCountSelector);
  const condQuery = useAppSelector(condQuerySelector);
  const currentPage = Number(page);
  const maxPage = Math.ceil(totalCount / JOB_COUNT_PER_PAGE);
  const hrefWithoutPage = `${DODA_SITE_URL.matchJobList}?${createQueryString(
    condQuery
  )}`;

  return (
    <Pager
      currentPage={currentPage}
      maxPage={maxPage}
      createPageHref={(pageNum) =>
        `${hrefWithoutPage}${pageNum === 1 ? '' : `&page=${pageNum}`}`
      }
    />
  );
};

const DEFAULT_QUERY = { pic: '1', ds: '0', so: '50', pf: '0', tp: '1' };

/**
 * クエリパラメータオブジェクトからクエリ文字列を生成する関数
 *
 * @param {AppQueryParams} condQuery - クエリパラメータオブジェクト
 * @returns {string} 生成されたクエリ文字列
 */
function createQueryString(condQuery: AppQueryParams) {
  const searchParams = new URLSearchParams(DEFAULT_QUERY);
  Object.keys(condQuery).forEach((key) => {
    const value = condQuery[key as keyof AppQueryParams];
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore TODO: value が string[] 型の可能性を考慮した処理に修正
    if (value) searchParams.set(key, value);
  });
  return searchParams.toString();
}
